import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Button, Tooltip } from 'reactstrap';

class CustomTooltip extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isHovered: false,
      isToggled: false,
    };
  }

    toggleTetelPopOver=(event) => {
      const { type } = event;
      if (type === 'mouseover') {
        this.setState({ isHovered: true });
      } else if (type === 'mouseout') {
        this.setState({ isHovered: false });
      } else if (type === 'focus') {
        this.setState({ isToggled: true });
      } else if (type === 'blur') {
        this.setState({ isToggled: false });
      }
    }

    render() {
      const { id, text, placement} = this.props;
      const { isHovered, isToggled } = this.state;
      // Tooltip szélesség
      let width;
      if (text.length > 450)
        width = 1000
      else if (text.length > 220)
        width = 600
      else
        width = 250;
      return (
        <span onMouseOver={this.toggleTetelPopOver} onMouseOut={this.toggleTetelPopOver} onFocus={this.toggleTetelPopOver} onBlur={this.toggleTetelPopOver}>
          <Button
            type="button"
            style={{ marginTop: 0, fontSize: '0.9em', ...this.props.style }}
            id={id}
            onClick={this.toggleTetelPopOver}
            className="table-action-icon transp-icon-button tooltip-button"
          >
            <i className="fa fa-info-circle" />
          </Button>
          <Tooltip
            placement={placement}
            target={id}
            delay={0}
            isOpen={isHovered || isToggled}
            innerClassName="tooltip-lg"
            style={{ whiteSpace: 'pre-line', textAlign: 'left', maxWidth: width }}
          >
            {text}
          </Tooltip>
        </span>
      );
    }
}

CustomTooltip.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  placement: PropTypes.string
};

CustomTooltip.defaultProps = {
  placement: 'auto'
};

export default CustomTooltip;
